import React from 'react';

const ProgrammeManual = () => {
  return (
    <>
      <div className="card border-primary">
        <div className="card-header bg-light p-2 border-primary" style={{"borderTop": "3px solid"}}><h6>Programme Manual</h6></div>
        <div className="card-body">
          <div className='row'>
            <div className='col-md-12'>
              <object data="/app/templates/2025-26/CDRI_Fellowship_Programme_Manual_2025-26.pdf" style={{width:'100%'}} height="900" type="application/pdf">
                <embed src="/app/templates/2025-26/CDRI_Fellowship_Programme_Manual_2025-26.pdf" style={{width:'100%'}} height="900" type="application/pdf"/>
              </object>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProgrammeManual;